import React from 'react';
import { PropTypes as RPT } from 'prop-types';


const Stepper = ({ questionNumber, activeQuestion, className }) => (
  <div className="step-list">
    <div className="container">
      {[...Array(questionNumber)].map((question, index) => (
        <div
          className={`
            step-list__item
            ${className}
            ${index < activeQuestion ? 'passed' : ''}
            ${index === activeQuestion ? 'active' : ''}
          `}
          key={index}
        >
          <span>{`${index + 1}`}</span>
        </div>
      ))}
    </div>
  </div>
);

Stepper.propTypes = {
  activeQuestion: RPT.number.isRequired,
  className: RPT.string,
  questionNumber: RPT.number.isRequired,
};

export default Stepper;
